import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import stripHtml from 'helper/stripHtml';
import { VideoProduct, VideosGetLast, videoProductToRoute } from 'helper/videos';
import { cssVar } from 'constants/theme';

export interface VideoCardProps {
  data: VideosGetLast;
  product: VideoProduct;
  isAdminView: boolean;
  onEdit: (id: number) => void;
  onDelete: (video: VideosGetLast) => void;
}

export default function VideoCard({
  data,
  product,
  isAdminView,
  onEdit,
  onDelete,
}: VideoCardProps) {
  const navigate = useNavigate();
  const productRoute = videoProductToRoute[product];
  const date = new Date(data.uri.release_time).toLocaleDateString('pt-BR');

  return (
    <div
      className="videos-mobile-card"
      role="button"
      tabIndex={0}
      onClick={() => navigate(`${productRoute}/${data.id}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') navigate(`${productRoute}/${data.id}`);
      }}
    >
      <div className="videos-mobile-card-thumb">
        <img src={data.uri.pictures?.base_link} alt={data.titulo} />
      </div>
      <div className="videos-mobile-card-body">
        <span className="videos-mobile-card-date">{date}</span>
        <h3 className="videos-mobile-card-title">{data.titulo}</h3>
        <p className="videos-mobile-card-desc">{stripHtml(data.description)}</p>
        {isAdminView && (
          <div className="videos-mobile-card-actions">
            <button
              type="button"
              aria-label="Editar vídeo"
              className="videos-mobile-card-action filled"
              onClick={(event) => {
                event.stopPropagation();
                onEdit(data.id);
              }}
            >
              <Icon iconType="edit" color={cssVar('text-on-accent')} size="small" />
            </button>
            <button
              type="button"
              aria-label="Excluir vídeo"
              className="videos-mobile-card-action filled"
              onClick={(event) => {
                event.stopPropagation();
                onDelete(data);
              }}
            >
              <Icon iconType="trash" color={cssVar('text-on-accent')} size="small" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
